import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';
import { RoverBrand } from '@rover/types/src/RoverBrand';

const DISPLAY_NAME = {
  [RoverBrand.Rover]: 'Rover',
  [RoverBrand.CatInAFlat]: 'Cat in a Flat',
  [RoverBrand.MadPaws]: 'Mad Paws',
};

export default (): string =>
  getBrandSpecificValue({
    rover: DISPLAY_NAME[RoverBrand.Rover],
    catInAFlat: DISPLAY_NAME[RoverBrand.CatInAFlat],
    madPaws: DISPLAY_NAME[RoverBrand.MadPaws],
  });
